import React from 'react';
import { Helmet } from 'react-helmet-async';

// Get API URL from environment variables with fallback
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const WS_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:5000';

// Some Chromium CSP matchers do not honor a path in a source expression,
// so allow the bare API origin as well (covers /api sub-paths everywhere).
const toOrigin = (raw: string) => {
  try {
    return new URL(raw).origin;
  } catch {
    return raw;
  }
};
const API_ORIGIN = toOrigin(API_URL);

interface DocumentHeadProps {
  title?: string;
  description?: string;
}

const DocumentHead: React.FC<DocumentHeadProps> = ({
  title = 'Data Marketplace',
  description = 'A modern data marketplace platform',
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Security Headers */}
      <meta 
        httpEquiv="Content-Security-Policy" 
        content={
          `default-src 'self'; ` +
          `base-uri 'self'; ` +
          `block-all-mixed-content; ` +
          `font-src 'self' https: data:; ` +
          `form-action 'self'; ` +
          `img-src 'self' data: https:; ` +
          `object-src 'none'; ` +
          `script-src 'self' 'unsafe-inline' 'unsafe-eval' https://js.paystack.co https://*.paystack.co https://vercel.live; ` +
          `script-src-attr 'none'; ` +
          `style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; ` +
          `style-src-elem 'self' 'unsafe-inline' https://fonts.googleapis.com; ` +
          `connect-src 'self' ${API_URL} ${API_ORIGIN} ${WS_URL} ws://localhost:5000 http://localhost:5000 ws://localhost:5000 http://192.168.0.233:5000 ws://192.168.0.233:5000 https://192.168.0.233:5000 wss://192.168.0.233:5000 https://api.paystack.co https://*.paystack.co https://checkout.paystack.com; ` +
          `frame-src 'self' https://checkout.paystack.com https://*.paystack.co https://js.paystack.co; ` +
          `upgrade-insecure-requests;`
        }
      />
      <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
      <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />
      <meta httpEquiv="Referrer-Policy" content="strict-origin-when-cross-origin" />
      
      {/* Other important meta tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0" />
      <meta name="theme-color" content="#ffffff" />
      
      {/* Favicon */}
      <link rel="icon" href="/favicon.ico" />
      <link rel="apple-touch-icon" href="/logo192.png" />
      <link rel="manifest" href="/manifest.json" />
    </Helmet>
  );
};

export default DocumentHead;
